import React, { useState, Fragment, useEffect } from "react";
import { Row, Col, Image } from "react-bootstrap";
import { SuggestionDropDownModelPopup } from "../../../superAdminReusable/reusablePopupSuperAdmin/superAdminSuggestionDropDownPopup/SuggestionDropDownModelPopup";
import moment from "moment";

export const ViewOpenIssuesTicketLeftMobile = (props) => {
  //state
  const [open, setOpen] = useState(false);

  const [statusDropDownText, setStatusDropDownText] = useState("");
  const handleStatusChange = (e, type) => {
    e.preventDefault();
    //setOpen(false);
    setStatusDropDownText(type);
  };
  const handleShowStatusList = () => {
    setOpen(true);
  };
  const handleCloseStatusList = () => {
    setStatusDropDownText(props.issueDetails && props.issueDetails.status);
    setOpen(false);
  };

  const onConfirmClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    setStatusDropDownText(props.issueDetails && props.issueDetails.status);
  }, [props.issueDetails && props.issueDetails.status]);

  const calcStatus = (status) => {
    if (status === 0) {
      return "New";
    } else if (status === 1) {
      return "In-Progress";
    } else if (status === 2) {
      return "Awaiting Feedback";
    } else if (status === 3) {
      return "On Hold";
    } else if (status === 4) {
      return "Re-Opened";
    } else if (status === 5) {
      return "Resolved";
    } else if (status === 6) {
      return "Closed";
    } else if (status === 7) {
      return "Archive";
    } else if (status === 8) {
      return "Called User";
    } else if (status === 9) {
      return "Completed";
    }
  };
  return (
    <React.Fragment>
      <div className="open_issues_view_tickets_left">
        <Row>
          <Col xs={12}>
            <div className="f20-700">Ticket Number : 12322222</div>
          </Col>
        </Row>
        {/* <Row> */}
        <hr />
        {/* </Row> */}
        <Row>
          <Col md={4} xs={4}>
            <div className="f12-700 mb-1 ">Request No</div>
            <div className="f11-400 mb-2">C137</div>
          </Col>
          <Col md={8} xs={8}>
            <div className="f12-700 mb-2">Seating Date</div>
            {props &&
            props.issueDetails &&
            props.issueDetails.diner_id &&
            props.issueDetails.diner_id.reservationTime ? (
              <div className="f11-400 mb-3">
                {" "}
                {moment(
                  props &&
                    props.issueDetails &&
                    props.issueDetails.diner_id &&
                    props.issueDetails.diner_id.reservationTime
                ).format("DD/MM/YYYY")}
              </div>
            ) : (
              <> </>
            )}
          </Col>
          {/* <Col md={4}>
            
          </Col> */}
        </Row>
        <hr />
        {/* <Row>
          <Col md={4} xs={4} className="d-flex flex-column align-items-start">
            <div className="f12-500 mb-2">Restaurant Name</div>
            <div className="d-flex flex-column align-items-center">
              <div className="enImage45 rounded-circle">
                <Image
                  //src={require("../../../../../assets/images/UserManagement/fhr7.png")}
                  src={
                    props.issueDetails &&
                    props.issueDetails.restaurant_id &&
                    props.issueDetails.restaurant_id.logo_url
                  }
                  alt="View"
                  title="View"
                  fluid
                  className="w-100 h-100"
                />
              </div>
              <div className="f14-500 text-center mt-1">
                {" "}
                {props.issueDetails &&
                  props.issueDetails.restaurant_id &&
                  props.issueDetails.restaurant_id.restaurant_name}
              </div>
            </div>
          </Col>
          <Col md={4} xs={4}>
            <div className="f12-500 mb-2">Address</div>
            <div className="f11-400 mb-2">
              {props.issueDetails &&
                props.issueDetails.restaurant_id &&
                props.issueDetails.restaurant_id.restaurant_address}
            </div>
          </Col>
          <Col md={4} xs={4}>
            <div className="f12-500 mb-2">Restaurant Number</div>
            <div className="f11-400 mb-3">+911234567890</div>
          </Col>
        </Row> */}
        <hr />
        <Row>
          <Col md={4} xs={4}>
            <div className="f12-500 mb-2">City</div>
            <div className="f11-400 mb-2">
              {" "}
              {props.issueDetails &&
                props.issueDetails.restaurant_id &&
                props.issueDetails.restaurant_id.city}
            </div>
          </Col>
          <Col md={4} xs={4}>
            <div className="f15-700 mb-1">Status</div>
            <div className="mb-2 text-white f9-700 bg-yellow enlblSelect">
              {calcStatus(props.issueDetails && props.issueDetails.status)}
              <SuggestionDropDownModelPopup
                onOpenModal={handleShowStatusList}
                status={statusDropDownText}
                open={open}
                displayButtonThree={true}
                displayButtonFour={true}
                displayButtonFive={true}
                displayButtonSix={true}
                onCloseModal={handleCloseStatusList}
                buttonTitle="Suggestion Status"
                buttonText="Suggestion Status"
                headerText="Suggestion Status"
                timeTextOne="New"
                timeTextTwo="In-Progress"
                timeTextThree="Awaiting - Feedback"
                timeTextFour="On-Hold"
                timeTextFive="Re-Opened"
                timeTextSix="Resolved"
                timeTextSeven="Closed"
                timeTextEight="Archive"
                timeTextNine="Called User"
                timeTextTen="Completed"
                timeOneClick={(e) => handleStatusChange(e, 0)}
                timeTwoClick={(e) => handleStatusChange(e, 1)}
                timeThreeClick={(e) => handleStatusChange(e, 2)}
                timeFourClick={(e) => handleStatusChange(e, 3)}
                timeFiveClick={(e) => handleStatusChange(e, 4)}
                timeSixClick={(e) => handleStatusChange(e, 5)}
                timeSevenClick={(e) => handleStatusChange(e, 6)}
                timeEightClick={(e) => handleStatusChange(e, 7)}
                timeNineClick={(e) => handleStatusChange(e, 8)}
                timeTenClick={(e) => handleStatusChange(e, 9)}
                onSubmit={
                  props &&
                  props.onSubmit &&
                  props.onSubmit(statusDropDownText, onConfirmClose)
                }
              />
            </div>
          </Col>
          <Col xs={4}>
            <div className="f12-500 mb-2">Issue Date</div>
            <div className="f11-400 mb-2">
              {moment(
                props.issueDetails && props.issueDetails.createdAt
              ).format("DD/MM/YYYY")}
            </div>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col md={12} xs={4} className="d-flex flex-column align-items-start">
            <div className="f12-500 mb-2">User Name</div>
            <div className="d-flex flex-column align-items-center">
              <div className="enIMG33 rounded-circle">
                {props.issueDetails &&
                props.issueDetails.user_id &&
                props.issueDetails.user_id.profile_photo &&
                props.issueDetails.user_id.profile_photo.length >= 1 ? (
                  <Image
                    fluid
                    src={props.issueDetails.user_id.profile_photo[0]}
                    alt="Icon"
                  />
                ) : (
                  <Image
                    fluid
                    src={require("../../../../../assets/images/ActionImages/demoprofile.jpg")}
                    alt="Icon"
                  />
                )}
              </div>
              <div className="f10-400 pt-2">
                {" "}
                {props.issueDetails &&
                  props.issueDetails.user_id &&
                  props.issueDetails.user_id.first_name}
              </div>
            </div>
          </Col>
          <Col xs={4}>
            <div className="f11-400 mb-2 ">Issue Type</div>
            <div className="f13-500 mb-2">Seating</div>
          </Col>
          <Col xs={4}>
            <div className="f11-400 mb-2 ">Issue Catgeory</div>
            <div className="f13-500 mb-2">Seating Not Allowed</div>
          </Col>
        </Row>
        <hr />

        <Row>
          <Col md={12}>
            <div className="f11-400 mb-2 text-gray">Issue Description</div>
            <div className="f13-500 mb-2">
              {props && props.issueDetails && props.issueDetails.description
                ? props.issueDetails.description
                : ""}
            </div>
            {/* <div className="f13-500 mb-2">Description</div> */}
          </Col>
        </Row>
        <hr />
        <Row>
          <Col md={12}>
            <div className="f11-400 mb-2 text-gray">Images</div>
            <div className="d-flex flex-wrap">
              {props.issueDetails &&
              props.issueDetails.refrence_images &&
              props.issueDetails.refrence_images.length >= 1 ? (
                <Fragment>
                  {props.issueDetails.refrence_images.map((image, index) => (
                    <div className="enIMG97 mr-2 mb-2" key={index}>
                      <Image
                        fluid
                        src={image[index]}
                        alt="image"
                        className="w-100 h-100"
                      />
                    </div>
                  ))}
                </Fragment>
              ) : (
                <Fragment> Image not available</Fragment>
              )}
            </div>
          </Col>
        </Row>
      </div>
      <div className="onboarding-map-setup-screen-autodetect-button">
        <div className="btn2 btn-lg btn btn-danger w-100 ml-2 mr-2">
          Submit Response
        </div>
      </div>
      {/* <Modal
        show={open}
        onHide={handleCloseStatusList}
        backdrop="static"
        keyboard={false}
        centered
        className="enStatusListModal"
        size="sm"
      >
        <Modal.Header closeButton>
          <Modal.Title className="f18-500 w-100 text-center">
            Suggestion Status
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul type="none" className="enStatusList">
            <li onClick={(e) => handleStatusChange(e, "Pending")}>New</li>
            <li onClick={(e) => handleStatusChange(e, "In-Process")}>
              In-Process
            </li>
            <li onClick={(e) => handleStatusChange(e, "Awaiting - Feedback")}>
              Awaiting - Feedback
            </li>
            <li onClick={(e) => handleStatusChange(e, "On-Hold")}>On-Hold</li>
            <li onClick={(e) => handleStatusChange(e, "Re-Opened")}>
              Re-Opened
            </li>
            <li onClick={(e) => handleStatusChange(e, "Resolved")}>Resolved</li>
            <li onClick={(e) => handleStatusChange(e, "Closed")}>Closed</li>
            <li onClick={(e) => handleStatusChange(e, "Archive")}>Archive</li>
            <li onClick={(e) => handleStatusChange(e, "Called User")}>
              Called User
            </li>
            <li onClick={(e) => handleStatusChange(e, "Completed")}>
              Completed
            </li>
          </ul>
        </Modal.Body>
      </Modal> */}
    </React.Fragment>
  );
};
